import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {Game} from "../Game";
import {FireFrameAnimName, GameFeatureMode, SYMBOL} from "../enums/Enum";
import {Config} from "../config/Config";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {Sound} from "../sound/Sound";

export class FireFrameRunner implements SimplePresentationRunner {
    shouldRun(): boolean {
        return true;
    }

    start(flowStateController: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        if (Game.model.xGodInReels[0] > -1) {
            Game.soundPlayer.fadeSound(1, 0, 500, Sound.REELS_SPINNING);
            Game.soundPlayer.fadeSound(1, 0, 500, Game.soundPlayer.currentMusic);
        }
        Game.fireFrameView.reset();
        let fireFrameCount: number = 0;
        let offset: number = 0.2;
        //bonus trigger will restrict xMental feature
        Game.model.gameData.fireFrames.forEach((reels: boolean[], reelId: number) => {
            const shouldPlayXMentalAnticipation: boolean = Game.model.xMentalPos.x === reelId && (Game.model.gameData.nextMode === GameFeatureMode.RESPIN || Game.model.gameData.nextMode === GameFeatureMode.NORMAL);
            let size: FireFrameAnimName;
            if (Game.model.gameData.fireReels[reelId]) {
                Game.foregroundElements.waysCounter.symCountInReels[reelId]++;
                Game.foregroundElements.waysCounter.symCountInReels[reelId]++;
                if (reelId === 2) {
                    size = FireFrameAnimName.SYMBOL_X2_HALF;
                } else if (reelId === 1 || reelId == 3) {
                    size = FireFrameAnimName.SYMBOL_X2;
                } else {
                    size = FireFrameAnimName.SYMBOL_X3;
                }
                const lockSize: number = Game.model.gameData.lockedFrameBefore[reelId][0];
                const shouldPlayXHoleAnticipation: boolean = reelId === 2 && Game.model.shouldPlayXHoleAnticipation();
                tl.add(Game.fireFrameView.play(reelId, 1, size, lockSize, shouldPlayXHoleAnticipation), offset);
                if (shouldPlayXMentalAnticipation) {
                    tl.add(() => {
                        Game.fireFrameView.playXMentalAnticipation(reelId, 1, true);
                    }, offset);
                }

                tl.add(() => {
                    for (let rowId: number = 0; rowId < Config.SYMBOLS_IN_REEL[reelId]; rowId++) {
                        fireFrameCount++;
                        //this.checkAndPlayLightTravelToEnhancer(reelId, rowId, fireFrameCount);
                    }
                    Game.enhancerView.setCount(fireFrameCount);
                }, offset);
                //play fireFrame sound per reel
                tl.add(() => {
                    Game.soundPlayer.playFireFrame();
                }, offset);
                offset += 0.1;
            } else {
                const shouldPlayXMentalAnticipation: boolean = Game.model.xMentalPos.x === reelId && (Game.model.gameData.nextMode === GameFeatureMode.RESPIN || Game.model.gameData.nextMode === GameFeatureMode.NORMAL);
                let fireFrameInReel: number = 0;
                reels.forEach((isFireFrame: boolean, rowId: number) => {
                    if (isFireFrame) {
                        Game.foregroundElements.waysCounter.symCountInReels[reelId]++;
                        if (reelId === 2 && rowId === 0) {
                            size = FireFrameAnimName.HALF;
                        } else {
                            size = FireFrameAnimName.SYMBOL;
                        }
                        const lockSize: number = Game.model.gameData.lockedFrameBefore[reelId][rowId];
                        const shouldPlayXHoleAnticipation: boolean = (reelId === 2 && rowId === 1) && Game.model.shouldPlayXHoleAnticipation();
                        tl.add(Game.fireFrameView.play(reelId, rowId, size, lockSize, shouldPlayXHoleAnticipation), offset);
                        if (shouldPlayXMentalAnticipation) {
                            tl.add(() => {
                                Game.fireFrameView.playXMentalAnticipation(reelId, rowId, false);
                            }, offset);
                        }
                        fireFrameInReel++;
                        tl.add(() => {
                            fireFrameCount++;
                            //this.checkAndPlayLightTravelToEnhancer(reelId, rowId, fireFrameCount);
                            Game.enhancerView.setCount(fireFrameCount);
                        }, offset + 0.1);
                    }
                });
                if (fireFrameInReel > 0) {
                    //play fireFrame sound per reel
                    tl.add(() => {
                        Game.soundPlayer.playFireFrame();
                    }, offset);
                    offset += 0.1;
                }
            }
            Game.foregroundElements.waysCounter.updatePossibleWaysCounter();

        });

        this.changeFakeReelSet(tl);

        if (tl.totalDuration() > 0) {
            tl.add(() => {
                flowStateController.finish();
            });
            if (Game.apiPlugin.settings.get(APISetting.FAST_SPIN, false)) {
                tl.timeScale(1.5);
            }
        } else {
            flowStateController.finish();
        }
    }

    private changeFakeReelSet(tl: gsap.core.Timeline) {
        if (Game.model.shouldPlayXHoleAnticipation()) {
            Game.reelView.reelModels[2].setReelSet(Config.XHOLE_REELSET);
            tl.add(() => {
                Game.reelView.reelModels[2].STEP_DURATION += 0.1;
            });
        } else {
            if (Game.model.gameData.reels[0].includes(SYMBOL.GOD)) {
                for (let reelId: number = 0; reelId < 4; reelId++) {
                    Game.reelView.reelModels[reelId + 1].setReelSet(Config.XGOD_REELSET);
                    // if (Game.model.gameData.reels[reelId].includes(SYMBOL.GOD)) {
                    //     Game.reelView.reelModels[reelId + 1].setReelSet(Config.XGOD_REELSET);
                    // }else{
                    //     Game.reelView.reelModels[reelId + 1].setReelSet(Config.XGOD_MISS_REELSET);
                    // }
                }
                Game.enhancerView.setDarkMode(true);
            } else {
                if (Game.model.gameData.mode === GameFeatureMode.NORMAL && Math.floor(Math.random() * 2) === 1) { //xMentalReel set //#431
                    if (Game.model.xMentalPos.x === -1) {
                        const random: number = Math.floor(Math.random() * 4);
                        Game.reelView.reelModels[random].setReelSet(Config.XMENTAL_REELSET);
                    } else {
                        const random: number = Math.floor(Math.random() * Game.model.xMentalPos.x);
                        Game.reelView.reelModels[random].setReelSet(Config.XMENTAL_REELSET);
                    }
                }
            }
        }
    }

    private checkAndPlayLightTravelToEnhancer(reelId: number, rowId: number, count: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        if (count === 4) {
            tl.add(Game.enhancerView.playFireBallToEnhancer(reelId, rowId, 0));
        } else if (count === 6) {
            tl.add(Game.enhancerView.playFireBallToEnhancer(reelId, rowId, 2));
        } else if (count === 8) {
            tl.add(Game.enhancerView.playFireBallToEnhancer(reelId, rowId, 1));
        }
        return tl;
    }

}